/**
 * @fileoverview Component for displaying an invite expired message.
 * This component includes a message indicating that the invite link is invalid and provides a link to contact the site PI for assistance.
 */

import NovoicDashboardLogo from '../../assets/novoic-dashboard-logo.svg'

/**
 * @function InviteExpired
 * @description Component for displaying an invite expired message.
 * @returns {JSX.Element} - A React component that renders the invite expired message.
 */
export default function InviteExpired() {
    return (
        <div className="nv-grid min-h-screen">
            <div className="md-container max-h-full items-center content-center justify-center col-start-1 md:col-start-2 lg:col-start-5">
                <div className="w-full max-w-md space-y-8">
                    <div className="flex flex-col items-center gap-y-4">
                        <NovoicDashboardLogo className="w-56" />
                        <h2 className="text-center text-3xl font-bold font-serif text-gray-900">
                            Invite link is invalid
                        </h2>

                        <p className="text-gray-600 font-regular text-center">
                            This invite link is invalid. Consider contacting your site PI for
                            assistance.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
